  <div class="page-header">
    <app-toolbar></app-toolbar>
  </div>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
  
